// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"ErrorContainer_warningIcon__R58dA"};